/* eslint-disable react-native/no-inline-styles */
import {
  Text,
  View,
  Image,
  useWindowDimensions,
  ViewStyle,
  TextStyle,
  ImageStyle,
} from 'react-native';
import React from 'react';
import {colors} from 'theme/Colors';
import {spacing} from 'theme/Units';
import {Button} from 'ui-kits';

type propType = Readonly<{
  openModal: () => void;
}>;

export function SignIn(props: propType) {
  const {openModal} = props;

  /**
   * responsiveness logic
   *  */
  let overridestyle = structuredClone(styles); // deep copy of base to override styles from base styles

  const {width: SCREEN_WIDTH} = useWindowDimensions();

  // breakpoint and style override
  if (SCREEN_WIDTH < 720) {
    overridestyle.boldText.fontSize = 46;
    overridestyle.iconContainer.width = 24;
    overridestyle.iconContainer.height = 44;
  }

  if (SCREEN_WIDTH < 640) {
    overridestyle.boldText.fontSize = 38;
    overridestyle.iconContainer.width = 20;
    overridestyle.iconContainer.height = 38;
    overridestyle.bgDisplayImage.width = 44;
    overridestyle.bgDisplayImage.height = 44;
  }
  if (SCREEN_WIDTH < 520) {
    overridestyle.boldText.fontSize = 30;
    overridestyle.bgDisplayImage.width = 36;
    overridestyle.bgDisplayImage.height = 36;
  }
  if (SCREEN_WIDTH < 480) {
    overridestyle.boldText.fontSize = 24;
    overridestyle.bgDisplayImage.width = 34;
    overridestyle.bgDisplayImage.height = 34;
  }
  if (SCREEN_WIDTH < 360) {
    overridestyle.boldText.fontSize = 20;
    overridestyle.iconContainer.width = 16;
    overridestyle.iconContainer.height = 30;
    overridestyle.bgDisplayImage.width = 30;
    overridestyle.bgDisplayImage.height = 30;
  }

  // image frames that consists of set of 3 images
  const leftImagesFrame = (
    <View style={styles.bgDisplayFrame}>
      <Image
        style={[
          styles.bgDisplayImage,
          overridestyle.bgDisplayImage,
          {rotate: '-15deg', marginRight: 20},
        ]}
        source={require('assets/images/signupSection/teams.jpg')}
      />
      <Image
        style={[
          styles.bgDisplayImage,
          overridestyle.bgDisplayImage,
          {rotate: '15deg', marginRight: 150},
        ]}
        source={require('assets/images/signupSection/settings.jpg')}
      />
      <Image
        style={[
          styles.bgDisplayImage,
          overridestyle.bgDisplayImage,
          {rotate: '-15deg', marginRight: 20},
        ]}
        source={require('assets/images/signupSection/timeline.jpg')}
      />
    </View>
  );

  const rightImagesFrame = (
    <View style={styles.bgDisplayFrame}>
      <Image
        style={[
          styles.bgDisplayImage,
          overridestyle.bgDisplayImage,
          {rotate: '-15deg', marginLeft: 20},
        ]}
        source={require('assets/images/signupSection/cloud.jpg')}
      />
      <Image
        style={[
          styles.bgDisplayImage,
          overridestyle.bgDisplayImage,
          {rotate: '15deg', marginLeft: 150},
        ]}
        source={require('assets/images/signupSection/chat.jpg')}
      />
      <Image
        style={[
          styles.bgDisplayImage,
          overridestyle.bgDisplayImage,
          {rotate: '-15deg', marginLeft: 40},
        ]}
        source={require('assets/images/signupSection/AI.jpg')}
      />
    </View>
  );

  return (
    <View style={styles.singinContainer}>
      <View style={styles.bgDisplayLayout}>
        {leftImagesFrame}

        {rightImagesFrame}
      </View>

      <View style={styles.singInHeadingWrapper}>
        <View style={styles.singinHeading}>
          <Text style={[styles.boldText, overridestyle.boldText]}>
            Ready to supercharge
          </Text>
          <View style={[styles.iconContainer, overridestyle.iconContainer]}>
            <Image
              source={require('assets/icons/thuder_bolt_purple@2x.png')}
              style={styles.icon}
            />
          </View>
          <Text style={[styles.boldText, overridestyle.boldText]}>your</Text>
        </View>

        <Text style={[styles.boldText, overridestyle.boldText]}>
          workflow?
          <Text style={styles.brandBlue}> Join now!</Text>
        </Text>
      </View>

      <Button text="sign in" variant="secondary" />
    </View>
  );
}

type styleProps = {
  singinContainer: ViewStyle;
  iconContainer: ViewStyle;
  icon: ImageStyle;
  boldText: TextStyle;
  bgDisplayLayout: ViewStyle;
  bgDisplayFrame: ViewStyle;
  bgDisplayImage: ImageStyle;
  brandBlue: TextStyle;
  singinHeading: ViewStyle;
  singInHeadingWrapper: ViewStyle;
};

const styles: styleProps = {
  singInHeadingWrapper: {
    alignItems: 'center',
  },
  singinHeading: {flexDirection: 'row', alignItems: 'center'},
  brandBlue: {color: colors.palette.brandBlue},
  singinContainer: {
    paddingVertical: spacing['16'],
    paddingHorizontal: spacing['2'],
    backgroundImage:
      'linear-gradient(to right, #DAD8FF 0%, #C9C1FF 25%, #E2BFFF 75%, #F4E8FF 100%)',
    backgroundColor: 'white',
    justifyContent: 'center',
    alignItems: 'center',
    gap: 24,
  },
  iconContainer: {
    position: 'relative',
    width: 30,
    height: 50,
    alignItems: 'center',
    marginTop: 15,
    marginHorizontal: 8,
  },
  icon: {
    resizeMode: 'contain',
    position: 'absolute',
    width: '100%',
    height: '100%',
  },
  boldText: {
    fontSize: 52,
    fontWeight: '600',
    color: 'white',
  },
  bgDisplayLayout: {
    position: 'absolute',
    width: '100%',
    height: '100%',
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
  },
  bgDisplayFrame: {
    flex: 1,
    justifyContent: 'space-between',
    alignItems: 'center',
    paddingVertical: spacing['4'],
  },
  bgDisplayImage: {
    width: 48,
    height: 48,
    resizeMode: 'contain',
    zIndex: -100,
  },
};
